// This file now serves as a compatibility bridge
// The main AudioRecorder component has been refactored into the AudioRecorder directory
import AudioRecorderComponent from "./AudioRecorder/AudioRecorder";

// Re-export the main component for backward compatibility
export default AudioRecorderComponent;

// Also export any other exports that might be used elsewhere
export * from "./AudioRecorder/AudioRecorder";
